import { OptionWithIdType } from '~/features/types';
import { getData } from '~/utils/service';
import { SPECIALTY_CERT_BY_SPECIALTY_ROUTE_NAME, SPECIALTY_CERT_ROUTE_NAME } from './constants';

export const SPECIALTY_CERT_API_CALLS = {
  getBySpecialty: async (props: {
    specialtyId: string;
    transformResponse?: (data: string) => OptionWithIdType[];
  }): Promise<OptionWithIdType[]> => {
    return await getData(SPECIALTY_CERT_BY_SPECIALTY_ROUTE_NAME, {
      pathParams: { specialtyId: props.specialtyId },
      transformResponse: props.transformResponse,
    });
  },
  get: async (props: {
    specId: string;
    transformResponse?: (data: string) => OptionWithIdType[];
  }): Promise<OptionWithIdType[]> => {
    return await getData(SPECIALTY_CERT_ROUTE_NAME, {
      pathParams: { specId: props.specId },
      transformResponse: props.transformResponse,
    });
  },
};
